import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, isAdmin, checkAdminStatus, adminCheckLoading } = useAuth();
  const [checking, setChecking] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const verifyAdmin = async () => {
      if (!user) {
        setChecking(false);
        setHasAccess(false);
        return;
      }

      // If we already know they're admin from localStorage, trust it initially
      if (isAdmin) {
        setHasAccess(true);
        setChecking(false);
        return;
      }

      // Otherwise check with the backend
      try {
        const adminStatus = await checkAdminStatus();
        setHasAccess(adminStatus);
      } catch (error) {
        console.error('Admin verification failed:', error);
        setHasAccess(false);
      } finally {
        setChecking(false);
      }
    };

    verifyAdmin();
  }, [user, isAdmin, checkAdminStatus]);

  if (checking || adminCheckLoading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.spinner}></div>
        <p style={styles.loadingText}>Verifying admin access...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const styles = {
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    fontFamily: '"Open Sans", sans-serif',
  },
  spinner: {
    width: '50px',
    height: '50px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #2c5aa0',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadingText: {
    marginTop: '20px',
    fontSize: '16px',
    color: '#666666',
    fontWeight: '500',
  },
};

export default AdminRoute;
